export default __webpack_public_path__ + "static/media/dashboard.88bdb6f4.png";